import { atom } from 'jotai';
import { isSameVideoReference } from '../utils/videoReference';

export const videosAwaitingApprovalAtom = atom([]);
videosAwaitingApprovalAtom.debugLabel = 'videosAwaitingApproval';

export const videoSearchResultsAtom = atom([]);
videoSearchResultsAtom.debugLabel = 'videoSearchResults';

export const STATSBOMB_DATA_SOURCE = 'STATSBOMB_DATA';

export const videoSearchMatchDataAtom = atom(null);
videoSearchMatchDataAtom.debugLabel = 'videoSearchMatchData';

export const videoSearchResultsAreUpdatingAtom = atom(false);
videoSearchResultsAreUpdatingAtom.debugLabel = 'videoSearchResultsAreUpdating';

export const videoSearchResultsErrorAtom = atom();
videoSearchResultsErrorAtom.debugLabel = 'videoSearchResultsError';

export const updateVideoSearchResultsAtom = atom(
  null,
  (get, set, videoReference, updatedVideoInfo) => {
    set(videoSearchResultsAtom, (videos) =>
      videos.map((video) => {
        const videoAsReference = {
          matchId: video.match_id,
          period: video.match_part,
          sport: video.sport,
          track: video.track,
          version: video.version,
        };

        return isSameVideoReference(videoAsReference, videoReference)
          ? { ...video, ...updatedVideoInfo }
          : video;
      }),
    );
  },
);
updateVideoSearchResultsAtom.debugLabel = 'updateVideoSearchResults';

export const removeVideoAwaitingApprovalAtom = atom(null, (_, set, key) => {
  set(videosAwaitingApprovalAtom, (videos) =>
    videos.filter((video) => video.key !== key),
  );
});
removeVideoAwaitingApprovalAtom.debugLabel = 'removeVideoAwaitingApproval';
